import FingerprintJS from '@fingerprintjs/fingerprintjs'
import SlsTracker from '@aliyun-sls/web-track-browser'
import { debounce } from 'throttle-debounce'

/*
 * 获取事件冒泡路径，兼容ie11,edge,chrome,firefox,safari
 * @param evt
 * @returns {*}
 */
function eventPath(evt) {
  const path = (evt.composedPath && evt.composedPath()) || evt.path,
    target = evt.target

  if (path != null) {
    return path.indexOf(window) < 0 ? path.concat(window) : path
  }

  if (target === window) {
    return [window]
  }

  function getParents(node, memo) {
    memo = memo || []
    const parentNode = node.parentNode

    if (!parentNode) {
      return memo
    } else {
      return getParents(parentNode, memo.concat(parentNode))
    }
  }

  return [target].concat(getParents(target), window)
}
export default async ({ app, store, $ga }, inject) => {
  let deviceID
  const fetchDeviceID = async () => {
    const fpPromise = FingerprintJS.load()
    try {
      await fpPromise
        .then((fp) => fp.get())
        .then((result) => {
          deviceID = result.visitorId
        })
    } catch {
      deviceID = null
    }
  }
  await fetchDeviceID()

  const opts = {
    host: 'ap-southeast-1.log.aliyuncs.com', // 所在地域的服务入口。
    project: 'event-tracking-project', // Project名称。
    logstore: process.env.CURRENT_MODE === 'production' ? 'event-tracking-loklok-pc' : 'event-tracking-loklok-pc-test' // Logstore名称。
  }
  const tracker = new SlsTracker(opts)
  // const router = useRouter()
  const isEmptyObject = (obj) => {
    return !obj || !Object.keys(obj).length
  }

  const isDisabled = (obj) => {
    return obj.hasOwnProperty('buryBtnDisabled') && obj.buryBtnDisabled == 'true'
  }
  const referrerCfg = {
    twitter: 'twitter',
    google: 'google',
    baidu: 'baidu',
    facebook: 'facebook',
    youtube: 'youtube',
    instagram: 'instagram',
    telegram: 'telegram'
  }

  const sourceCfg = {
    index: '首页',
    all: '所有内容',
    collection: '片单详情页',
    search: '搜索结果页',
    detail: '详情播放页',
    error: 'error页',
    sitemap: 'sitemap',
    joinUs: '加入我们',
    404: '404页',
    articles: '文章资讯',
    article: '文章页',
    contact: '联系我们',
    download_nd: '下载页',
    download: '老版下载页'
  }
  const ownReferrer = ['loklok']
  // const ownReferrer = ['loklok', 'localhost']

  const getInnerReferrerPage = () => {
    const lowerReferrer = document.referrer?.toLowerCase()
    const referrerFromInner = lowerReferrer && ownReferrer.some((item) => lowerReferrer.includes(item))
    const innerReferrerKey = Object.keys(sourceCfg).filter((item) => lowerReferrer.includes(item.toLowerCase()))[0]
    const innerReferrerPage = referrerFromInner ? (innerReferrerKey ? sourceCfg[innerReferrerKey] : '首页') : ''
    return innerReferrerPage
  }
  inject('getInnerReferrerPage', getInnerReferrerPage)

  const newFilters = store.getters.filterParams
  if (newFilters.length) {
    newFilters.forEach((item) => {
      // 分类页为动态数据
      sourceCfg[item.websiteParam?.toLowerCase()] = item.websiteParam
    })
  }
  // web数据埋点
  class LokBury {
    constructor() {
      this.pageFrom = {} // 页面从哪里来
      this.pageCurrent = {} // 当前页面
      this.buryList = []
      this.buryEnv = ['production', 'mytest', 'development'] // 需要埋点的环境
      // this.pageNameFields = ['UM_Key_PageName', 'UM_Key_ExposurePage', 'UM_Key_PlayPage', 'UM_Key_PlayPage'] // 涉及页面名称 统一增加web前缀的
      // this.appRelatedFields = ['UM_Key_SourcePage'] // app会传参 优先取参数的
      this.buryExposureList = [] //已上报曝光数据的domID
      this.addListenner()
    }

    // 添加全局的埋点监听
    addListenner() {
      this.addViewListener()
      this.addClickListener()
      this.addScrollListener()
    }
    // 监听页面的路由更改
    addViewListener() {
      const handleViewMD = () => {
        const data = {
          type: 'pageView',
          page: {
            from: this.pageFrom,
            current: this.pageCurrent
          },
          data: {
            buryEventId: 'UM_Event_PageView'
          }
        }
        this.recordMD(data)
      }
      // 记录路由数据
      app.router.beforeEach((to, from, next) => {
        setTimeout(() => {
          this.pageFrom = from
          this.pageCurrent = to
          !to?.meta?.noBury && handleViewMD()
          // 清除已内容曝光数据
          this.buryExposureList = []
          next()
        }, 0)
        // setTimeout(next, 0)
      })

      // 推送已存在的埋点数据
      app.router.afterEach(() => {
        this.buryList.length && this.pushOrigin()
        this.buryList = []
      })
    }

    // 监听点击事件
    addClickListener() {
      document.onclick = (e) => {
        let i = 0,
          path = eventPath(e)
        //if (!e.path) return;

        while (i < path?.length) {
          const data = path[i].dataset
          if (!isEmptyObject(data) && !isDisabled(data)) {
            // 如果data-bury-params存在的时候，才进行埋点
            if (data.buryParams) {
              i = path.length
              this.handleMD(data)
            }
          }
          i++
        }
      }
    }

    // 监听滚动事件
    addScrollListener() {
      window.addEventListener(
        'scroll',
        debounce(200, () => {
          this.exposureSearch()
        }),
        true
      )
    }
    exposureSearch = () => {
      const childList = Array.from(document.getElementsByClassName('bury-exposure'))
      childList.length &&
        childList.forEach((item) => {
          if (!this.buryExposureList.includes(item.id) && this.isInViewport(item) && item.id && item.dataset?.exposureParams) {
            const data = {
              type: 'exposure',
              page: {
                from: this.pageFrom,
                current: this.pageCurrent
              },
              data: item.dataset
            }
            this.recordMD(data)
            this.pushOrigin()
            this.buryExposureList.push(item.id)
          }
        })
    }

    isInViewport = (target) => {
      const divH = target.offsetHeight // div高度
      const windowH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight // 浏览器高度兼容写法
      const windowW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth // 浏览器高度兼容写法
      const obj = this.getRect(target)
      if (
        obj.top >= 0 &&
        obj.top < windowH &&
        obj.bottom > 0 &&
        (obj.bottom <= windowH || divH >= windowH) &&
        ((obj.left >= 0 && obj.left < windowW && obj.right > 0 && obj.right <= windowW) || (obj.left < 0 && obj.right > windowW))
      ) {
        // 在视口中: 1.top\bottom都在视口内 2.top在视口内bottom在视口外 3.left right都在视口内 4.left<0 right>视口width
        return true
      }
      return false
    }

    getRect = (element) => {
      const rect = element.getBoundingClientRect() // 距离视窗的距离
      const top = document.documentElement.clientTop ? document.documentElement.clientTop : 0 // html元素对象的上边框的宽度
      const left = document.documentElement.clientLeft ? document.documentElement.clientLeft : 0
      return {
        top: rect.top - top,
        bottom: rect.bottom - top,
        left: rect.left - left,
        right: rect.right - left
      }
    }

    //手动埋点
    handleMD = (dataset, type) => {
      const data = {
        type: type || 'click',
        page: {
          from: this.pageFrom,
          current: this.pageCurrent
        },
        data: dataset
      }
      this.recordMD(data)
      // setTimeout(this.pushOrigin, 0)
      this.pushOrigin()
    }

    // 记录埋点数据
    recordMD(data) {
      console.warn(data)
      console.log('%c记录数据埋点...', 'color: red;')
      this.buryList.push(data)
    }
    /**
     * @description 埋点数据上报
     * */
    pushOrigin() {
      const changeData = (data) => {
        const type = typeof data
        return type === 'string' ? JSON.parse(data) : data
      }
      this.buryList.forEach((obj, idx) => {
        const lowerReferrer = document.referrer?.toLowerCase()
        const fromOthers = lowerReferrer && ownReferrer.every((item) => !lowerReferrer.includes(item))
        const referrerKey = Object.keys(referrerCfg).filter((item) => lowerReferrer?.includes(item.toLowerCase()))[0]
        const innerReferrerPage = getInnerReferrerPage()
        const currentPageTitle = obj.page?.current?.meta?.pageTitle
        const fromPageTitle = obj.page?.from?.meta?.pageTitle
        const currentSourcePage = obj.page?.current?.meta?.sourcePage
        const querySourcePage = obj.page?.current?.query?.source
        const referrerName = fromOthers && referrerKey ? referrerCfg[referrerKey] || '三方页面' : null
        const defaultUserInfo = {
          // UM_Key_PageName: currentPageTitle || null,
          // UM_Key_SourcePage: querySourcePage || fromPageTitle || null,
          referrer: document.referrer,
          UA: navigator.userAgent,
          deviceID,
          UM_Key_UserID: store.state.user.userInfo?.id || null,
          UM_Key_UserType: store.state.user.token ? (store.state.user.userInfo.vip ? '会员' : '已登录用户') : '未登录用户', //todo 待处理是否为vip
          UM_Key_UserLevel: null,
          local_time: Date.now ? Date.now() : new Date().getTime()
        }
        if (obj.data?.buryEventId === 'UM_Event_PageView') {
          defaultUserInfo.UM_Key_PageName = currentPageTitle
          defaultUserInfo.UM_Key_SourcePage = fromOthers ? referrerName : sourceCfg[querySourcePage?.toLowerCase()] || currentSourcePage || fromPageTitle || innerReferrerPage || null
        }
        if (this.buryEnv.includes(process.env.NODE_ENV) && obj) {
          let params
          let eventId
          obj.data = changeData(obj?.data)
          if (obj.type === 'click') {
            // 点击事件
            params = {
              ...defaultUserInfo,
              UM_Key_SourcePage: currentPageTitle,
              ...changeData(obj?.data?.buryParams)
            }
            eventId = obj?.data?.buryEventId ? obj.data.buryEventId : 'UM_Event_ModularClick'
          } else if (obj.type === 'exposure') {
            // 内容曝光
            params = {
              ...defaultUserInfo,
              ...changeData(obj?.data?.exposureParams)
            }
            eventId = 'UM_Event_ContentExposure'
          } else if (obj.type === 'custom') {
            //自定义内容上报
            params = {
              ...defaultUserInfo,
              ...changeData(obj.data.buryParams)
            }
            eventId = obj.data.buryEventId
          } else if (obj.type === 'pageView') {
            // 页面访问
            params = {
              ...defaultUserInfo,
              UM_Key_PageName: currentPageTitle || null
              // UM_Key_SourcePage: querySourcePage || (currentSourcePage === null ? null : currentSourcePage || fromPageTitle || null)
            }
            obj.page?.current?.meta?.buryParams && Object.assign(params, obj.page?.current?.meta?.buryParams)
            eventId = 'UM_Event_PageView'
          }
          const eventName = { UM_Key_EventName: eventId }
          // 站外使用阿里云Web Tracking埋点
          tracker.send({ ...eventName, ...params })
          console.log('%c推送埋点数据....', 'color: red;')
          console.log({ ...eventName, ...params })
        }
        if (idx === this.buryList.length - 1) {
          this.buryList = []
        }
      })
    }
  }

  const lokBury = new LokBury()
  // nuxtApp.provide('bury', (option) => {
  //   tracker.send(option)
  // })
  inject('LokBury', lokBury)
}
